import { Injectable } from '@angular/core';
import { from, map, Observable } from 'rxjs';
import PouchDB from 'pouchdb';
import PouchDBFind from 'pouchdb-find';

PouchDB.plugin(PouchDBFind);
interface EmployeeDoc {
  _id: string;
  firstname: string;
  lastname: string;
  name?: string;
  email: string;
  phone: string;
  organizationUuid: string;
}

@Injectable({
  providedIn: 'root',
})
export default class EmployeeService {
  private db = new PouchDB('employee');
  all(): Observable<EmployeeDoc[]> {
    const promise = this.db
      .find({
        selector: { type: 'employee' },
      })
      .then((res) => res.docs as unknown as EmployeeDoc[]);

    return from(promise).pipe(
      map((employees) => {
        return employees.map((e) => ({ ...e, name: `${e.firstname} ${e.lastname}` }));
      }),
    );
  }

  findByUuids(uuids: string[]): Observable<EmployeeDoc[]> {
    const promise = this.db
      .find({
        selector: { type: 'employee', $or: [{ uuid: { $in: uuids } }, { _id: { $in: uuids } }] },
      })
      .then((res) => res.docs as unknown as EmployeeDoc[]);

    return from(promise);
  }

  get(id: string) {
    const promise = this.db
      .find({
        selector: { type: 'employee', _id: id },
      })
      .then((res) => res.docs as unknown as EmployeeDoc[]);

    return from(promise);
  }
}
